


























import { defineComponent, useRoute, useRouter } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Components
import Errors from '@/components/global/errors/Errors.vue'

// Composable
import useKnowledgeBase from '@/composables/learn-and-support/useKnowledgeBase'
import useKnowledgebaseAnalytics from '~/composables/analytics/useKnowledgebaseAnalytics'

// Store
import { useKnowledgeBaseStore } from '~/store/knowledge-base'

// Types
import { ElasticContentFieldTypeInterface } from '@/types/search/elasticTypes'
import { QueryStyle } from '~/types/search/searchTypes'
import useSearchAnalytics from '~/composables/analytics/useSearchAnalytics'

export default defineComponent({
  name: 'SupportSearchInputField',

  components: {
    Errors,
  },

  setup() {
    const knowledgeBaseStore = useKnowledgeBaseStore()
    const { typeahead, knowledgebaseErrors } = storeToRefs(knowledgeBaseStore)
    const { hasTypeaheadResults, getSupportArticleLink, getSupportArticlesLink } = useKnowledgeBase()
    const { trackSiteSearch } = useSearchAnalytics()
    const { trackKnowledgebaseArticleClick } = useKnowledgebaseAnalytics()
    const route = useRoute()
    const router = useRouter()

    // Show the title of the typeahead result
    const showTypeaheadTitle = (title: ElasticContentFieldTypeInterface) => {
      return title.snippet ?? title.raw
    }

    const seeAllClick = () => {
      knowledgeBaseStore.setCurrentPage(1)
      knowledgeBaseStore.setQueryStyle(QueryStyle.KEYWORD)

      router.push(getSupportArticlesLink())
    }

    // On a click, send analytics and change window location
    const onTypeaheadClick = (articleNumber: string, urlname: string, index: number, title: string) => {
      trackSiteSearch({
        index_type: 'knowledgebase',
        search_origin: route.value.path,
        query_typed: knowledgeBaseStore.typedSearchInput,
        query_executed: title,
        results_quantity: undefined,
        results_page_quantity: undefined,
        filters: undefined,
        response_time: undefined,
        sort_by: undefined,
        query_style: QueryStyle.TYPEAHEAD_REDIRECT,
      })

      trackKnowledgebaseArticleClick({
        type: 'typeahead',
        clickedArticleTitle: title,
        clickedArticlePosition: index,
      })
      window.location.href = getSupportArticleLink(articleNumber, urlname)
    }

    return {
      typeahead,
      knowledgebaseErrors,
      hasTypeaheadResults,
      showTypeaheadTitle,
      onTypeaheadClick,
      getSupportArticlesLink,
      seeAllClick,
    }
  },
})
